import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { formatAmount, removeNonDigits } from '~/helpers/formatters.helper';
import NumberInputField from '~/components/shared/Input/NumberInputField';
import { getCurrency } from '@qred/shared-component-library/src/currency';
import { LoanAmountDefaultValues } from '~/constants/markets';

interface LoanAmountProps {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  defaultValue?: string;
  value?: string;
  label?: string;
  dataCy?: string;
}

const LoanAmount = ({
  onBlur,
  onChange,
  value,
  name,
  label,
  dataCy,
}: LoanAmountProps) => {
  const { market } = useSelector((state: RootState) => state.intl);

  const defaultAmount = LoanAmountDefaultValues[market].min * 10;

  const defaultValues = {
    onBlur,
    onChange,
    value: value || '',
    name,
    label,
  };

  return (
    <NumberInputField
      {...defaultValues}
      dataCy={dataCy}
      validationType="LoanAmount"
      placeholder={formatAmount(
        Number(removeNonDigits(defaultAmount.toString()))
      )}
      rightText={defaultValues.value ? getCurrency(market).unit : ''}
      data-record
    />
  );
};

export default LoanAmount;
